import request from '@/utils/request'

export function getOrderInfo() {
  return request({
    url:'/statistics/statisticsOrderInfo',
    method:'get',
  })
}
export function getStaticSalsInfo() {
  return request({
    url:'/statistics/statisticsSalesValue',
    method:'get',
  })
}

export function getOrderGeneralViewData() {
  return request({
    url:'/statistics/statisticsOrderGeneralView',
    method:'get',
  })
}

export function getChartsCountData(params) {
  return request({
    url:'/statistics/getOrderCountByDateRange',
    method:'get',
    params:params
  })
}
export function getChartsSalesData(params) {
  return request({
    url:'/statistics/getSalesValueByDateRange',
    method:'get',
    params:params
  })
}

export function getShopInfo() {
  return request({
    url:'/account/query',
    method:'get',
  })
}

export function getVerifyCode() {
  return request({
    url:'/account/cashOut/verifyCode',
    method:'get',
  })
}

export function requestCashOut(data) {
  return request({
    url:'/account/apply',
    method:'post',
    data:data
  })
}

export function updateGroup(data) {
  return request({
    url:'/group/update',
    method:'post',
    data:data
  })
}
export function creatGroup(data) {
  return request({
    url:'/group/create',
    method:'post',
    data:data
  })
}

export function deleteGroup(bid) {
  return request({
    url:'/group/delete/'+bid,
    method:'post'
  })
}

export function statisticsOrderDayInfo() {
  return request({
    url:'/statistics/statisticsOrderDayInfo',
    method:'get',
  })
}

export function statisticsSales(dataType) {
  return request({
    url:`/statistics/statisticsSales/` + dataType,
    method:'get',
  })
}

export function getDayInfo() {
  return request({
    url:'/statistics/getOrderDayInfo',
    method:'get',
  })
}

export function getOrderSalesByMonth() {
  return request({
    url:'/statistics/getOrderSalesByMonth',
    method:'get',
  })
}

export function getManageAnalysis(dataType) {
  return request({
    url:`/statistics/getManageAnalysis/` + dataType,
    method:'get',
  })
}